import {DatePipe} from '@angular/common';
import {Component, ViewChild} from '@angular/core';
import {ConfirmationService, MenuItem} from 'primeng/api';
import {ToastService} from '../../../../services/toast.service';
import {Adiantamento} from '../../../../types/Adiantamento.type';
import {Instancia} from '../../../../types/Instancia.type';
import {Table} from 'primeng/table';
import { AdiantamentoService } from './adiantamento.service';
import { IntegradorService } from '../../../../services/integrador.service';
import { ProcessoFolha } from '../../../../types/ProcessoFolha.type';

@Component({
  selector: 'app-adiantamento',
  templateUrl: './adiantamento.component.html',
  styleUrl: './adiantamento.component.css',
  providers: [DatePipe, ConfirmationService],
})
export class AdiantamentoComponent {
  @ViewChild('dt') table!: Table;
  iconeCheckbox: string = "T"
  selecionados: boolean = false;

  itensReversao: MenuItem[];

  status: any[] = [{name: 'Integrado', value: 'INTEGRADO'}
    , {name: 'Pendente Integração', value: 'NAO_INTEGRADO'}
    , {name: 'Estornado', value: 'ESTORNADO'}
    , {name: 'Cancelado', value: 'CANCELADO'}
    , {name: 'Erro', value: 'ERRO'}
  ]

  adiantamentos: Adiantamento[] = [];
  adiantamentosSelecionados: Adiantamento[] = [];
  processando: boolean = false;
  loadingSincronizar: boolean = false;
  loadingIntegrar: boolean = false;
  processo!: string;
  instancias: Instancia[] = [];
  instanciaSelecionada!: string;
  rangeDates!: string;
  processosSelecionados: ProcessoFolha[] = [];
  processos: ProcessoFolha[] = [];

  constructor(
    private adiantamentoService: AdiantamentoService,
    private toastService: ToastService,
    private datePipe: DatePipe,
    private confirmationService: ConfirmationService
  ) {
    this.itensReversao = [
      {
        label: 'Cancelar',
        icon: 'pi pi-times',
        command: () => {
          this.cancelar();
        },
      },
      {
        label: 'Estornar no PIMS',
        icon: 'pi pi-undo',
        command: () => {
          this.estornar();
        },
      },
      {
        label: 'Cancelar e Estornar',
        icon: 'pi pi-times-circle',
        command: () => {
          this.cancelarEstornar();
        },
      },
    ];
  }

  ngOnInit(): void {
    this.carregaProcessos();
    this.getAdiantamentos();
  }

  carregaProcessos() {

    this.adiantamentoService.getProcessos().subscribe({
      next: (data) => {
        this.processos = data;
      },
      error: (error) => {
            this.processando = false;
            this.toastService.erro(
              'Erro',
              'Erro ao buscar as informações: ' + error.error.message
            );
          },
      complete: () => {
        this.processando = false;
      },
    })
  }

  getAdiantamentos() {
    this.adiantamentos = [];
    this.adiantamentosSelecionados = []

    if (
      this.instanciaSelecionada != undefined &&
      this.rangeDates != undefined &&
      this.processosSelecionados != undefined
    ) {
      let dataInicial = this.getDataPipeTransForm(this.rangeDates[0]);
      let dataFinal = this.getDataPipeTransForm(this.rangeDates[1]);

      this.processando = true;

      let processos = this.processosSelecionados.map(p => p.codigo).join(',');

      this.adiantamentoService
        .getPagamentos(this.instanciaSelecionada, dataInicial, dataFinal, processos)
        .subscribe({
          next: (data) => {
            this.adiantamentos = data;
          },
          error: (error) => {
            this.processando = false;
            this.toastService.erro(
              'Erro',
              'Erro ao buscar as informações: ' + error.error.message
            );
          },
          complete: () => {
            this.processando = false;
          },
        });
    } else {
      this.toastService.alerta('Filtros', 'Informe os filtros necessários');
    }
  }

  sincronizar() {
    if (
      this.instanciaSelecionada != undefined &&
      this.rangeDates != undefined &&
      this.processosSelecionados != undefined
    ) {
      this.loadingSincronizar = true;

      this.processando = true;

      let dataInicial = this.getDataPipeTransForm(this.rangeDates[0]);
      let dataFinal = this.getDataPipeTransForm(this.rangeDates[1]);

      let processos = this.processosSelecionados.map(p => p.codigo).join(',');

      this.adiantamentoService
        .buscaPagamentos(
          this.instanciaSelecionada,
          dataInicial,
          dataFinal,
          processos
        )
        .subscribe({
          next: (value) => {
            this.toastService.sucesso('Sucesso', 'Busca realizada');
            this.adiantamentos = [];
            this.processando = false;
          },
          error: (err) => {
            this.loadingSincronizar = false;
            this.processando = false;
            this.toastService.erro(
              'Erro',
              'Erro na solicitação: ' + err.error.message
            );
          },
          complete: () => {
            this.loadingSincronizar = false;
            this.processando = false;
            this.getAdiantamentos();
          },
        });
    } else {
      this.toastService.alerta('Filtros', 'Informe os filtros necessários');
    }
  }

  integrar() {
    if (
      this.instanciaSelecionada != undefined &&
      this.rangeDates != undefined
    ) {
      if (this.adiantamentosSelecionados.length > 0) {
        this.loadingSincronizar = true;
        this.processando = true;

        let dataInicial = this.getDataPipeTransForm(this.rangeDates[0]);
        let dataFinal = this.getDataPipeTransForm(this.rangeDates[1]);

        let ids = this.adiantamentosSelecionados.map(m => m.idPagto)

        let corpo = {
          ids: ids,
          usuario: localStorage.getItem("cdUsuarioErp")
        }

        this.adiantamentoService
          .enviaPagamentosErp(
            ids
          )
          .subscribe({
            next: (value) => {
              this.toastService.sucesso('Sucesso', 'Execução realizada');
            },
            error: (err) => {
              this.loadingSincronizar = false;
              this.processando = false;
              this.toastService.erro(
                'Erro',
                'Erro na solicitação: ' + err.error.message
              );
            },
            complete: () => {
              this.loadingSincronizar = false;
              this.processando = false;
              this.getAdiantamentos();
            },
          });
      } else {
        this.toastService.alerta("Filtros", "Selecione um ou mais registros para integração")
      }
    } else {
      this.toastService.alerta('Filtros', 'Informe os filtros necessários');
    }
  }

  getStatus(status: string): string {
    let stt = '';

    switch (status) {
      case 'INTEGRADO':
        stt = 'Integrado';
        break;
      case 'RETORNO_ID':
        stt = 'Enviando ao PIMS';
        break;
      case 'NAO_INTEGRADO':
        stt = 'Aguardando Integração';
        break;
      case 'CANCELADO':
        stt = 'Cancelado';
        break;
      case 'ESTORNADO':
        stt = 'Estornado';
        break;
      case 'ERRO':
        stt = 'Erro';
        break;
      case 'ERRO_PIMS':
        stt = 'Erro PIMS';
        break;
    }

    return stt;
  }

  getSeverity(status: string): string {
    let stt = '';

    switch (status) {
      case 'INTEGRADO':
        stt = 'success';
        break;
      case 'ERRO':
        stt = 'danger';
        break;
      case 'ERRO_PIS':
        stt = 'danger';
        break;
      default:
        stt = 'info';
        break;
    }

    return stt;
  }

  getDataPipeTransForm(data: string): string | null {
    return this.datePipe.transform(data, 'yyyy-MM-dd');
  }

  exportar() {

    if (this.adiantamentosSelecionados.length > 0) {
      this.loadingSincronizar = true
      this.processando = true

      let dataInicial = this.getDataPipeTransForm(this.rangeDates[0]);
      let dataFinal = this.getDataPipeTransForm(this.rangeDates[1])

      console.log(this.adiantamentosSelecionados)

      let ids = this.adiantamentosSelecionados.map(m => m.idPagto)

      let corpo = {
        ids: ids,
        usuario: localStorage.getItem("cdUsuarioErp")
      }

      this.adiantamentoService
        .exportarPagamentos(
          ids
        )
        .subscribe({
          next: (value) => {
            const url = window.URL.createObjectURL(value);
            const a = document.createElement('a')
            a.href = url
            a.download = 'data.xlsx'
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          },
          error: (error) => {
            this.toastService.erro("Exportar", 'Erro ao exportar:' + error.error);
            this.loadingSincronizar = false;
            this.processando = false;
          },
          complete: () => {
            this.loadingSincronizar = false;
            this.processando = false;
          },

        });
    } else {
      this.toastService.alerta("Serviços", "Selecione registro para envio");
    }
  }

  cancelar() {
    if (
      this.adiantamentosSelecionados.filter((ad) => ad.fgStatusInteg != 'INTEGRADO' && ad.fgStatusInteg != 'NAO_INTEGRADO' && ad.fgStatusInteg != 'ERRO_PIMS').length >
      0 ||
      this.adiantamentosSelecionados.length == 0
    ) {
      this.toastService.alerta('', 'Selecione apenas registros integrados');

      return;
    }

    // this.loadingInteg = true;

    let ids = this.adiantamentosSelecionados.map((m) => m.idPagto);

    let corpo = {
      ids: ids,
      usuario: localStorage.getItem('cdUsuarioErp'),
    };

    console.log(corpo);

    this.confirmationService.confirm({
      message: 'Tem certeza que deseja cancelar os itens selecionados? Essa operação é irreversível',
      header: 'Confirmar',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'none',
      acceptButtonStyleClass: 'bg-red-500',
      rejectIcon: 'none',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => {
         this.adiantamentoService.cancelarPagamento(corpo).subscribe({
          next: (value) => {
            this.toastService.sucesso('Sucesso', 'Cancelamento realizado');
          },
          error: (err) => {
            this.toastService.erro(
              'Erro',
              'Erro na solicitação: ' + err.error.message
            );
          },
          complete: () => {
            this.loadingIntegrar = false;
            this.getAdiantamentos();
            this.adiantamentosSelecionados = [];
          },
        });
      },
    });
  }

  estornar() {
    if (
      this.adiantamentosSelecionados.filter((ad) => ad.fgStatusInteg != 'CANCELADO').length >
      0 ||
      this.adiantamentosSelecionados.length == 0
    ) {
      this.toastService.alerta('', 'Selecione apenas registros cancelados');

      return;
    }

    // this.loadingInteg = true;

    let ids = this.adiantamentosSelecionados.map((ad) => ad.idPagto);

    let corpo = {
      ids: ids,
      usuario: localStorage.getItem('cdUsuarioErp'),
    };

    this.confirmationService.confirm({
      message: 'Tem certeza que deseja estornar os itens selecionados no PIMS? Essa operação é irreversível',
      header: 'Confirmar',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'none',
      acceptButtonStyleClass: 'bg-red-500',
      rejectIcon: 'none',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => {
        this.adiantamentoService.estornatPagamento(corpo).subscribe({
          next: (value) => {
            this.toastService.sucesso('Sucesso', 'Estorno realizado');
          },
          error: (err) => {
            console.error(err)
            this.toastService.erro(
              'Erro',
              'Erro na solicitação: ' + err.error
            );
          },
          complete: () => {
            this.loadingIntegrar = false;
            this.getAdiantamentos();
            this.adiantamentosSelecionados = [];
          },
        });
      },
    });
  }

  selecionarRegistros(event: any) {

    if (event.checked) {
      if (!this.table) return;
      if (this.adiantamentos.length > 0) {

        let dadosFiltradosOrdenados = this.table.filteredValue || this.table.value
        const primeiroRegistro = this.table.first ?? 0;
        const linhasPorPagina = this.table.rows ?? 0;
        const ultimoRegistro = Math.min((primeiroRegistro + linhasPorPagina), this.adiantamentos.length);
        dadosFiltradosOrdenados = dadosFiltradosOrdenados.slice(primeiroRegistro, ultimoRegistro);
        this.adiantamentosSelecionados = this.adiantamentosSelecionados.filter(prov => !dadosFiltradosOrdenados.includes(prov))
        this.adiantamentosSelecionados = [...this.adiantamentosSelecionados, ...dadosFiltradosOrdenados]
      }
    } else {

      if (this.adiantamentosSelecionados.length == this.adiantamentos.length) {
        this.adiantamentosSelecionados = []
      } else {
        // Limpa apenas os registros visiveis na pagina atual
        let dadosFiltradosOrdenados = this.table.filteredValue || this.table.value

        const primeiroRegistro = this.table.first ?? 0;
        const linhasPorPagina = this.table.rows ?? 0;
        const ultimoRegistro = Math.min((primeiroRegistro + linhasPorPagina), this.adiantamentos.length);
        dadosFiltradosOrdenados = dadosFiltradosOrdenados.slice(primeiroRegistro, ultimoRegistro)
        this.adiantamentosSelecionados = this.adiantamentosSelecionados.filter(prov => !dadosFiltradosOrdenados.includes(prov))
      }
    }

    this.defineIconeCheckBox()
  }


  defineIconeCheckBox() {

    if (!this.table) return;

    if (this.adiantamentos.length > 0) {
      let dadosFiltradosOrdenados = this.table.filteredValue || this.table.value

      const primeiroRegistro = this.table.first ?? 0;
      const linhasPorPagina = this.table.rows ?? 0;
      const ultimoRegistro = Math.min((primeiroRegistro + linhasPorPagina), this.adiantamentos.length);

      const resultado = this.compareArrays(dadosFiltradosOrdenados.slice(primeiroRegistro, ultimoRegistro), this.adiantamentosSelecionados);
      if (this.adiantamentosSelecionados.length == dadosFiltradosOrdenados.length || this.adiantamentosSelecionados.length == this.adiantamentos.length) this.iconeCheckbox = "Todos"
      else if (resultado != "Nenhum") this.iconeCheckbox = "Parcial"
      else this.iconeCheckbox = "Nenhum"
      if (this.iconeCheckbox !== "Nenhum") this.selecionados = true
      else this.selecionados = false

    } else {
      this.iconeCheckbox = "Nenhum"
      this.selecionados = false
    }
  }


  onPageChange(event: any) {
    setTimeout(() => {
      this.defineIconeCheckBox();
    }, 0);
  }

  compareArrays<T>(arrayA: T[], arrayB: T[]): 'Todos' | 'Parcial' | 'Nenhum' {
    if (arrayA.length === 0) return 'Nenhum';
    const setB = new Set(arrayB);
    const countInB = arrayA.filter(item => setB.has(item)).length;
    if (countInB === 0) return 'Nenhum';           // Nenhum
    if (countInB === arrayA.length) return 'Todos'; // Todos
    return 'Parcial';                                // Alguns (parcial)
  }


  /**
   * Handler quando seleção muda
   */
  onSelectionChange() {

    setTimeout(() => {
      this.defineIconeCheckBox();
    }, 0);
  }


  /**
   * Handler de filtro
   */
  onFilter(event: any) {
    setTimeout(() => {
      this.defineIconeCheckBox();
    }, 0);
  }

  selectionarTodos(){

    this.adiantamentosSelecionados = [...this.adiantamentos]
    this.defineIconeCheckBox()
  }

  cancelarEstornar() {
    if (
      this.adiantamentosSelecionados.filter((ad) => ad.fgStatusInteg != 'INTEGRADO' && ad.fgStatusInteg != 'NAO_INTEGRADO' && ad.fgStatusInteg != 'ERRO_PIMS').length >
      0 ||
      this.adiantamentosSelecionados.length == 0
    ) {
      this.toastService.alerta('', 'Selecione apenas registros integrados');

      return;
    }

    // this.loadingInteg = true;

    let ids = this.adiantamentosSelecionados.map((m) => m.idPagto);

    let corpo = {
      ids: ids,
      usuario: localStorage.getItem('cdUsuarioErp'),
    };

    console.log(corpo);

    this.confirmationService.confirm({
      message: 'Tem certeza que deseja cancelar os itens selecionados?',
      header: 'Confirmar',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'none',
      acceptButtonStyleClass: 'bg-red-500',
      rejectIcon: 'none',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => {
        this.adiantamentoService.postCancelarEstornarFolha(corpo).subscribe({
          next: (value) => {
            this.toastService.sucesso('Sucesso', 'Solicitação realizada');
          },
          error: (err) => {
            this.toastService.erro(
              'Erro',
              'Erro na solicitação: ' + err.error.message
            );
          },
          complete: () => {
            this.loadingIntegrar = false;
            this.getAdiantamentos();
            this.adiantamentosSelecionados = [];
          },
        });
      },
    });
  }
}
